import NormalGameManager from "../../manager/NormalGameManager";
import {BatchingBinCacheEntity, NormalBackpackType} from "../../manager/DefineInterface";
import O1HD from "../../../../engines/gameEngine";
import {BUNDLE_SMALL_NAME, getOneBundleOnePrefab} from "../../BundleResourceConfig";
import BackpackPrefab from "../backpack/BackpackPrefab";
import {backpackOpenType} from "../../config/backpackConst";
import {EggEntity, getEggById} from "./config/EggConfig";
import data_control from "../../../../engines/libs/data_control";

const {ccclass, property} = cc._decorator;
/**
 * 孵化仓
 */
@ccclass
export default class HatchingBinNode extends cc.Component {

    @property({type:cc.Node,displayName:"父节点"})
    parentNode : cc.Node = null;

    private mGameLayer : NormalGameManager;

    onLoad () {
        O1HD.on( "HatchingBinNode.checkEnterEgg" , this.checkEnterEgg , this );
    }

    start () {
        this.mGameLayer = NormalGameManager._instance;
        //如果没有初始化数据
        if ( !this.mGameLayer.getGameData().batchingBinData ){
            this.mGameLayer.getGameData().batchingBinData = [];
            this.mGameLayer.writeGameData();
        }
        if ( !this.mGameLayer.getGameData().chickenCoop.batchingBinCount ) {
            this.mGameLayer.getGameData().chickenCoop.batchingBinCount = 2;
            this.mGameLayer.writeGameData();
        }
        this.refreshData();
        this.schedule(()=>{
            O1HD.emit("HatchingBinItemNode.setTimerDown" );
        },1);
    }

    /**
     * 关闭
     */
    async onBtnClick(){
        let url = "backpack/backpackPrefab";
        let prefab = await getOneBundleOnePrefab( BUNDLE_SMALL_NAME.backPackGameBundle , url );
        if ( prefab ) {
            let backpack = cc.instantiate(prefab);
            backpack.getComponent(BackpackPrefab).bindData(backpackOpenType.select,NormalBackpackType.egg,( item )=>{
                if ( item.id < 21001 || item.id > 21999 ) {
                    O1HD.getModules().uiControlModule.showMessageBox("请选择鸡蛋");
                    return;
                }
                //添加一个孵化Item
                this._addHatchingItem( item.id , ( ret  ) => {
                    if ( ret ) {
                        //背包库存 -1
                        NormalGameManager._instance.onOutGoods( item.id , 1 );
                    }
                } );
            },( item )=>{})
            this.parentNode.addChild(backpack);
        }
    }


    /**
     * 刷新孵化仓数据
     */
    refreshData(){
        //孵化仓，判断是否孵化完成
        let batchingBinArray = NormalGameManager._instance.getGameData().batchingBinData;
        for ( let i = 0 ; i < batchingBinArray.length ; i ++ ) {
            let hour = NormalGameManager._instance.mGameHours - batchingBinArray[i].startGameHour;
            let minute = NormalGameManager._instance.mMinute - batchingBinArray[i].startGameMinute;
            let eggEntity = getEggById( batchingBinArray[i].eggId );
            let hasLiveSeconds = data_control.getSeconds( hour , minute );
            if ( hasLiveSeconds >= eggEntity.hatchingSeconds ) {
                //孵化成功
                let chickId = this.getHatchingResult( eggEntity );
                if( chickId == -1 ){
                    O1HD.getModules().uiControlModule.showMessageBox("孵化失败");
                    batchingBinArray.splice( i , 1 );
                    i --;
                }else{
                    batchingBinArray[i].chickenId = chickId;
                }
            }
        }

        for ( let i = 0 ; i < batchingBinArray.length ; i ++ ) {
            O1HD.emit( "HatchingBinItemNode.activeItem" , i , batchingBinArray[i] );
        }

        NormalGameManager._instance.writeGameData();
    }

    //获取孵化结果
    getHatchingResult( eggEntity : EggEntity ) : number {
        let weightAll : number = 0;
        for ( let hatchingRule of eggEntity.hatchingSpecies ) {
            weightAll += hatchingRule.weight;
        }
        let randomNum = Math.floor( Math.random() * weightAll );
        let chickId : number = null;
        for ( let hatchingRule of eggEntity.hatchingSpecies  ) {
            if ( randomNum <= hatchingRule.weight ) {
                chickId = hatchingRule.chickenId;
                break;
            }
            randomNum -= hatchingRule.weight;
        }
        return chickId;
    }

    /**
     * 检查是否收入蛋
     * @param worldPos
     * @param eggId
     * @param callback
     */
    checkEnterEgg( worldPos : cc.Vec2 , eggId : number , callback : (ret :boolean)=>{}){
        if ( this.node.getBoundingBoxToWorld().contains( worldPos ) ) {
            // 判定鸡蛋类型是否可 收入孵化
            this._addHatchingItem( eggId , callback );
        }else{
            callback(false);
        }
    }


    private _addHatchingItem( eggId : number , callback ){
        if ( ( this.mGameLayer.getGameData().batchingBinData.length + this.mGameLayer.getGameData().chickenData.length )
            >= this.mGameLayer.getGameData().chickenCoop.capacity ) {
            O1HD.getModules().uiControlModule.showMessageBox("孵化加鸡数量已达到鸡仓上限" );
            callback(false);
            return;
        }
        if ( eggId == 21002 || eggId == 21003 || eggId == 21007 ) {
            callback(false);
            O1HD.getModules().uiControlModule.showMessageBox("该鸡蛋不可孵化" );
            return;
        }
        //判断当前是否满了
        if ( this.mGameLayer.getGameData().batchingBinData.length >= this.mGameLayer.getGameData().chickenCoop.batchingBinCount ){
            O1HD.getModules().uiControlModule.showMessageBox("孵化仓已满,请解锁孵化仓");
            return;
        }

        //收入
        callback( true );
        let batchingBinArray = this.mGameLayer.getGameData().batchingBinData;
        let batchingBinCacheEntity : BatchingBinCacheEntity = {
            uniqueId : new Date().getTime(),
            eggId : eggId,
            startGameHour : this.mGameLayer.mGameHours,
            startGameMinute : this.mGameLayer.mMinute
        };
        batchingBinArray.push( batchingBinCacheEntity );
        this.mGameLayer.writeGameData();
        //刷新孵化仓数据
        this.emitHatchingItem( batchingBinCacheEntity );
    }

    //激活
    emitHatchingItem( batchingBinCacheEntity , index ?: number ){
        let indexNum = !index ? 0 : index;
        O1HD.emit("HatchingBinItemNode.activeItem" , indexNum , batchingBinCacheEntity ,()=>{
            this.emitHatchingItem( batchingBinCacheEntity ,indexNum + 1 );
        });
    }

}
